const {
  REACT_APP_CDN,
  REACT_APP_QMETIS_API,
  REACT_APP_QAPI,
  REACT_APP_JANUS_API,
  REACT_APP_EMAIL_SERVICE_API,

  REACT_APP_CDN_PROD,
  REACT_APP_QAPI_PROD,
  REACT_APP_JANUS_API_PROD,
  REACT_APP_EMAIL_SERVICE_API_PROD,
  REACT_APP_QMETIS_API_PROD,
} = process.env;

const env = "testing";
const isStaging = env === "testing";
export const corsBypass = ""; // "http://0.0.0.0:8080/";
// export const corsBypass = "https://cors-anywhere.herokuapp.com/";

export const REACT_APP_DEV_CDN = isStaging ? REACT_APP_CDN : REACT_APP_CDN_PROD;
export const REACT_APP_BASE_URL_METIS = isStaging
  ? REACT_APP_QMETIS_API
  : REACT_APP_QMETIS_API_PROD;
export const REACT_APP_BASE_URL_QALORT = isStaging
  ? REACT_APP_QAPI
  : REACT_APP_QAPI_PROD;
export const REACT_APP_BASE_URL_JANUS = isStaging
  ? REACT_APP_JANUS_API
  : REACT_APP_JANUS_API_PROD;
export const REACT_APP_BASE_URL_EMAIL_SERVICE = isStaging
  ? REACT_APP_EMAIL_SERVICE_API
  : REACT_APP_EMAIL_SERVICE_API_PROD;
